// Validation Regex Patterns
const Validation = Object.freeze({
  tel: /^($|\+[0-9()\s-]+$)/,
  email: /^($|[\w!#$%&'*+=?`{|}~^-]+(?:\.[\w!#$%&'*+=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,30}$)/,
  iban: /^($|([A-Z]{2}[0-9]{2})([0-9A-Z]){11,30}$)/,
  bic: /^($|[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$)/,
});

export default Validation;
